import { Controller } from 'stimulus';

class NewsletterController extends Controller {
  toggleForm() {
    this.element.classList.add('is-open');
  }
}

NewsletterController.targets = [
  'formToggler',
];

export default NewsletterController;
